<template>
  <div>
    <v-tooltip top v-if="tooltipLabel">
      <template v-slot:activator="{ on }">
        <label class="i-checkbox" :class="`i-${color}`" v-on="on">
          <span class="i-checkbox-label"> <br> </span>
          <input ref="checkbox" type="checkbox" v-model="isChecked" @input="handleInput($event)" @change="handleChange($event)" :checked="value">
          <span class="checkmark"></span>
        </label>
      </template>
      <span>{{ label }}</span>
    </v-tooltip>
    <label class="i-checkbox" :class="`i-${color}`" v-else>
      <span class="i-checkbox-label">{{ label }}</span>
      <input ref="checkbox" type="checkbox" v-model="isChecked" @input="handleInput($event)" @change="handleChange($event)" :checked="value">
      <span class="checkmark"></span>
    </label>
  </div>
</template>

<script>
export default {
  name: 'checkbox',
  props: {
    label: {
      type: [String, Number, Boolean],
      default: null
    },
    value: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: 'primary'
    },
    tooltipLabel: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    this.$refs.checkbox.checked = this.value
  },
  updated () {
    this.$refs.checkbox.checked = this.value
  },
  computed: {
    isChecked: {
      get: () => {
        return this.value
      },
      set: () => {
        return this.value
      }
    }
  },
  methods: {
    handleInput (e) {
      this.$emit('input', e.target.checked)
    },
    handleChange (e) {
      this.$emit('change', e.target.checked)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ui/checkbox.vue